import { useMutation, useQuery } from '@tanstack/react-query';

import cycleAudienceService from './cycleAudienceService';

import type { CycleAudience } from '@/types/cycle-evaluation/CycleAudience';

import { queryClient } from '@/AppWithProviders';
import {
    CycleAudienceMutationKey,
    CycleAudienceQueryKey,
    CycleEvaluationQueryKey,
} from '@/constants/QueryKeys';

const useUpdateCycleAudience = () => {
    return useMutation<CycleAudience, Error, CycleAudience>({
        mutationKey: [CycleAudienceMutationKey.UPDATE_CYCLE_AUDIENCE],
        mutationFn: (cycleAudience: CycleAudience) =>
            cycleAudienceService.updateCycleAudience(cycleAudience),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [CycleEvaluationQueryKey.CYCLE_EVALUATION],
            });
        },
    });
};

const useGetCycleAudience = ({ cycleAudienceId }: { cycleAudienceId: string }) => {
    return useQuery<CycleAudience, Error, CycleAudience>({
        queryKey: [CycleAudienceQueryKey.GET_CYCLE_AUDIENCE],
        queryFn: () => cycleAudienceService.getCycleAudience(cycleAudienceId),
        enabled: !!cycleAudienceId,
    });
};

export { useUpdateCycleAudience, useGetCycleAudience };
